import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ZonesPropertiesService } from 'src/app/service/zones-properties.service';
import { ELEMENTS } from 'src/app/data/elements';
import { DATA } from 'src/app/data/data';
import { DataService } from 'src/app/service/data.service';
import { PrintService } from 'src/app/service/print.service';
import { ElementsService } from 'src/app/service/elements.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.less']
})
export class ProductsComponent implements OnInit {

  zones=[];  

  data:any=DATA;
  rooms:any;
  project_name:string=null;
  client_name:string=null;
  @ViewChild('results') resultsRef: ElementRef;
  
  constructor(
    private zonesPropertiesService: ZonesPropertiesService,
    private dataService: DataService,
    public elementsService: ElementsService,  
    private modalService: NgbModal,      
    private printService : PrintService
    ) {       
    this.zonesPropertiesService.addZones(ELEMENTS.zones);
    this.zones=this.zonesPropertiesService.zonesProperties;
      
    this.dataService.populateRoomsDataFromDb();
    this.dataService.getDataFromDb()
    this.data=this.dataService.currentData;
    this.rooms=this.dataService.getRoomsAsObject()
  }  

  canvasBase=null;
  print_url:string=null;

  ngOnInit() {        
    this.print_url=this.printService.url;
    
    this.dataService.data$.subscribe((data: any)=>{ 
      this.rooms=this.dataService.getRoomsAsObject() 
      this.data=data;
    })

    this.elementsService.elements$.subscribe(data => {
      this.zonesPropertiesService.addZones(data['zones'])
      // this.initZones()
    });
    
    this.elementsService.calculateAreas()
    this.zonesPropertiesService.appendNames(this.elementsService.getContour(),this.elementsService.getZones())
    this.zones=this.zonesPropertiesService.zonesProperties;

    // console.log(this.printService.createCanvas().toDataURL)
    this.canvasBase=this.printService.createCanvas().toDataURL();
  }

  printResults(){   
    this.printService.print()    
  }

  
  setBackgroundModal(content){
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

}
